import axios from "axios";
import { BASE_URL } from "../../Helper/Helper";

const ScreeningState = {
  addScreening: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v1/admin/create-screening`,
      requestOptions,
      {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      },
    );

    let datas = response.data.data;
    return datas;
  },

  getScreening: async () => {
    // FETCH API CALL For all notes
    const response = await axios.get(`${BASE_URL}/api/v1/admin/get-screening`, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    let datas = response.data.data;
    return datas;
  },

  deleteScreening: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.delete(
      `${BASE_URL}/api/v1/admin/delete-screening/${id}`,
      {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      },
    );

    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },

  updateScreening: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.put(
      `${BASE_URL}/api/v1/admin/update-screening/${id}`,
      requestOptions,
    );

    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },
};

export default ScreeningState;
